module.exports = __webpack_public_path__ + "img/credit-one-club-gal-1.18cf540b.jpg";